export default interface VersionPickerResponse {
  versions: { [key: string]: string } | null;
  errorMessage: string;
}

export const emptyVersionPickerResponse = Object.seal(<VersionPickerResponse>{
  versions: null,
  errorMessage: '',
});
